import axios from "axios";
import { apiURL } from "constants/constants";
import 'react-dotenv';


const axiosPrivate = axios.create({
     baseURL: apiURL,// || BASE_URL,
     headers: { 'Content-Type': 'application/json' },
});

axiosPrivate.interceptors.request.use(
    config => {
        const token = localStorage.getItem("token") || '';
       // config.headers['Authorization'] = `Bearer ${token}`;

        console.log('apiURL',apiURL);
        if (!config.headers['Authorization']) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    }, (error) => Promise.reject(error)
);

axiosPrivate.interceptors.response.use(
    (response) => response?.data || response,
    async (error) => {
        const originalRequest = error.config;

        // If the error status is 401 and there is no originalRequest._retry flag,
        // it means the token has expired and we need to refresh it
        if ((error.response.status === 401) && !originalRequest._retry) {
            originalRequest._retry = true;
            
            console.log('error.response', originalRequest);
            
            if(originalRequest.url !== '/login') {
            window.location.href = '/login';
            }
            else{
                return Promise.reject(error);
            }
        }
        if (error.response.status === 500) {
            //return Promise.reject('Some error occured while processing the request. Please try again.');
            return Promise.reject(error);
            //return error.response?.data || error.response;
        }
  
        return Promise.reject(error);
    }
);

export default axiosPrivate;